export default __webpack_public_path__ + "static/133-min-min-6887825952b865446a9183ef4b79531a.jpg";